import { useTranslation } from 'react-i18next';

export const OnboardCancel = () => {
    const { t } = useTranslation(['company']);
    return (
        <>{t('company:onboard.cancel.message')}</>
    )
}
